module.exports = __webpack_public_path__ + "img/pvc-680g-weiss-transluzent.845834a2.jpg";